// 書籍、評論、特輯連載頁面
import axios from 'axios'
import {API_URL} from './config.js'

export default {
  getNewsSliderL: function () {
    axios.get(`${API_URL}/News/SliderL`,this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      this.slides = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  getNewsSliderM: function () {
    axios.get(`${API_URL}/News/SliderM`,this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      this.slidesMNews = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  getNewsListByType: function (type = 1, page = 1, search_str = "") {
    let params = {
      type: type,
      page: page
    }
    if (search_str) {
      this.search_str = search_str;
      search_str = "?SearchStr=" + this.search_str;
    }
    axios.get(`${API_URL}/News/List/${this.getParams(params, false)}${search_str}`,this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      this.newsListItem = response.data
      this.mySelected = type
      if(window.location.pathname == "/news"){
        this.setNewsPage(response.data,page)
      }
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  setNewsPage: function(data , page){
    var thisItem = this
    var waitForEl = function (selector, callback) {
      if (jQuery(selector).length) {
          callback();
      } else {
          setTimeout(function () {
              waitForEl(selector, callback);
          }, 100);
      }
    };
    var search_str = this.search_str;
    waitForEl(".pageSelect", function(){
        var pageItem = new SimplePagination(data.TotalPage, page)
        if(data.TotalPage){
          pageItem.init({
              container: ".pageSelect",
              maxShowBtnCount: 5,
              onPageChange: state => {
                  thisItem.getNewsListByType($(".newsListItem .custom-select>select").val(), state.pageNumber, search_str)
              }
          })
        }else{
          $("#pageSelect>.pagination").remove()
        }
    })
  },
  getNewsContent: function (id = "a02b3bc8-7c3d-4372-ab4a-08d5e8915714", preview = false) {
    let params = {
      id: id,
      super: preview
    }
    axios.get(`${API_URL}/News/${params['id']}?super=${params['super']}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      this.news = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  }
}



// WEBPACK FOOTER //
// ./src/news.js